import { render, staticRenderFns } from "./ReceiptPaymentSummary.vue?vue&type=template&id=a3499c6c"
import script from "./ReceiptPaymentSummary.vue?vue&type=script&lang=js"
export * from "./ReceiptPaymentSummary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports